export class FooterAccordion {
    private items: NodeListOf<HTMLElement>;

    constructor(selector: string) {
        this.items = document.querySelectorAll<HTMLElement>(selector);
        this.init();
        window.addEventListener('resize', () => this.reset());
    }

    private init() {
        this.items.forEach(item => {
            const head = item.querySelector<HTMLElement>('.footer-contact__head');
            const content = item.querySelector<HTMLElement>('.footer-contact__elements');
            if (!head || !content) return;

            // Начальная высота
            content.style.overflow = 'hidden';
            content.style.transition = 'height 0.3s ease';

            head.addEventListener('click', () => {
                if (window.innerWidth >= 991) return; // Только для мобильных

                const isActive = item.classList.contains('active');
                if (isActive) {
                    // Скрываем
                    content.style.height = '0';
                    item.classList.remove('active');
                } else {
                    // Показываем
                    const scrollHeight = content.scrollHeight;
                    content.style.height = scrollHeight + 'px';
                    item.classList.add('active');
                }
            });
        });
    }

    private reset() {
        // При ресайзе >991px сбрасываем все
        if (window.innerWidth >= 991) {
            this.items.forEach(item => {
                const content = item.querySelector<HTMLElement>('.footer-contact__elements');
                if (!content) return;
                content.style.height = '';
                item.classList.remove('active');
            });
        } else {
            // На мобильных закрываем все элементы
            this.items.forEach(item => {
                const content = item.querySelector<HTMLElement>('.footer-contact__elements');
                if (!content) return;
                if (!item.classList.contains('active')) {
                    content.style.height = '0';
                } else {
                    content.style.height = content.scrollHeight + 'px';
                }
            });
        }
    }
}

